export const getThirdFlowId = state => state.thirdFlows.thirdFlow.id;
export const getThirdFlowData = state => state.thirdFlows.thirdFlow;
export const thirdFlowIsFetching = state => state.thirdFlows.loading;